import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_REPORTGEN';

const he = {
    sortDirection: 'בחרו אם למיין בסדר עולה או בסדר יורד.',
    myReports: 'הדו"חות שלי',
    exitForm: 'סגירת מסך',
    reportName: 'שם הדו"ח',
    baseForm: 'מסך בסיס',
    createdOn: 'תאריך יצירה',
    createdBy: 'נוצר ע"י',
    updated: 'תאריך עדכון',
    shared: ' משותף',
    share: 'שיתוף',
    edit: 'עריכה',
    run: ' הפקה',
    duplicate: 'שכפול',
    delete: 'מחיקה',
    deleteMsg: 'Are you sure tou want delete this report?',
    newReport: 'דו"ח חדש',
    formSelectHelp: 'בחרו אחד מטיפוסי הדו"ח ואח"כ בחרו את מסך הבסיס לדו"ח',
    selectBaseForm: ' בחירת מסך בסיס',
    selectFormPlaceHolder: 'בחירה מרשימה',
    ok: 'אישור',
    cancel: 'ביטול',
    save: 'שמירה ',
    runReport: 'הפקת הדו"ח',
    runChart: 'הפקת הגרף',
    baseFormLabel: 'מסך בסיס',
    reportNameLabel: 'לכתוב שם לד"וח',
    multiCheckBox: 'רב חברתי',
    tabularCheckBox: 'דו"ח טבלאי',
    addFieldBtn: 'הוספת שדות',
    addExpressBtn: 'הוספת ביטוי',
    selectFieldTitle: 'בחירת שדות',
    selectFieldHelp: 'Select field help',
    exitNoSave: 'האם לצאת בלי לשמור את השינויים?',

    //31 -
    yes: 'כן',
    no: 'לא',
    fieldsTableName: 'שם',
    fieldsTableId: 'מספר מזהה',
    fieldsTableNewName: 'שם חדש בדו"ח ',
    fieldsTableWidth: 'רוחב ',
    fieldsTableInput: 'קלט ',
    fieldsTableGroup: 'קיבוץ',
    fieldsTableGroupTitle: 'קיבוץ בכותרת',
    fieldsTablegroupFunction: 'פונקציית קיבוץ',
    fieldsTableRepeatValue: 'חזרה על הערך בסיכום',
    fieldsTableGroupTotalOnly: 'Group Total',
    fieldsTablegroupNone: 'None',
    fieldsTableGroupFunctionHelp: 'Help',
    reportListType: 'טיפוס',
    fieldsTableReportTotalOnly: 'Report Total',
    fieldsTableTotalBoth: 'Both',
    fieldsTableGroupMain: 'ראשי',
    fieldsTableGroupSecondary: 'משני:',
    fieldsTableHidden: 'מוסתר',
    fieldsTableSort: 'סדר',
    fieldsTableFunction: 'פעולה ',
    fieldsTableFunctionSum: 'סכום',
    fieldsTableFunctionAvg: 'ממוצע ',
    fieldsTableFunctionMax: 'מקסימום',
    fieldsTableFunctionMin: 'מינימום',
    fieldsTableXaxis: 'ציר X ',
    fieldsTableExp: 'ביטוי/פורמט',
    deleteField: 'מחיקה ',
    companyName: 'שם חברה', //52
    expression: 'ביטוי  ', //53
    analyticsToolTip: 'Priority Analytics', //54
    analyticsHelp:
        'כלי Analytics חדשני המאפשר ליצור דו"חות מותאמים אישית בצורה נוחה ואינטואטיבית.\nבעזרת טכנולוגיה פורצת דרך, תוכלו לבנות דו"חות שישלבו ויציגו נתונים מכמה עולמות תוכן בפריוריטי אשר יסייעו בקבלת תובנות מהירות.\n\nכדי ליצור דו"ח, לחצו על הכפתור "דו"ח חדש" והגדירו את השדות שיוצגו באופן גמיש ממגוון מסכים.\n\nמרשימת "הדו"חות שלי" אפשר להפעיל דו"חות שמורים שיצרתם בעבר ולשתף אותם עם משתמשים אחרים.\n\nראו הסברים נוספים ב- Priority Xpert.',
    oldGenToolTip: 'This reports was created via old Reports generator', //56
    oldGenEditToolTip: 'You can still edit the report in the original reportgenerator.', //57
    emptyStateTitle: 'דו"חות מותאמים אישית', //58
    emptyStateSubTitle: 'כאן יופיעו הדו"חות שלך, אחרי בנייה של לפחות דו"ח אחד', //59
    newReportBtn: 'דו"ח חדש', //60
    analyticsReportHelp:
        'כאן תוכלו לבצע את הגדרות הדו"ח: שם דו"ח, שיתוף דו"ח, הגדרת דו"ח כרב-חברתי, בחירת שדות לדו"ח, וכן להגדיר אפשרויות נוספות לעמודות הדו"ח, כמו: מיון וקיבוץ נתונים, פעולות מתמטיות אגרגטיביות והוספת עמודות ביטוי מותאמות אישית שבהן תוכלו להגדיר חישובים נוספים.\n\nראו הסברים נוספים ב-Priority Xpert.',
    analyticsChartHelp:
        'במסך זה תוכלו להגדיר את נתוני התרשים והתצורה שלו.\n\nבכותרת המסך תוכלו לקבוע הגדרות כלליות לתרשים, כמו כותרת התרשים ושיתוף התרשים.\n\nאח"כ הגדירו את נתוני הדוח בלשוניות:\n\n- בלשונית "סוג" בחרו את סוג התרשים.\n\n- בלשונית “נתונים” הגדירו את שדות נתוני התרשים ואת הפעולות שמבצעים על הנתונים כמו מיון וקיבוץ נתונים ופעולות מתמטיות. בנוסף, תוכלו להגדיר ביטויים מותאמים אישית לחישובים נוספים.\n\n- בלשונית מימדים הגדירו אילו שדות ישמשו צירים או מימדים אחרים בתרשים.\n\nראו הסברים נוספים ב-Priority Xpert.',
    sharedHelp: 'help', //62
    multiCompanyHelp: 'help', //63
    tabularHelp:
        'סמנו את התיבה כדי ליצור דו”ח המציג את הערכים של שדה שנבחר בדו”ח כעמודות הדו”ח (ציר X).', //64
    idNumberHelp: 'id number help', //65
    nameInReportHelp: 'name in report help', //66
    widthHelp: 'width help', //67
    inputHelp: 'input help', //68
    groupHelp: 'group help', //69
    groupTitle: 'group title help', //70
    hiddenHelp: 'hidden help', //71
    sortHelp: 'Sort help', //72
    functionHelp: 'function help', //73
    axisHelp: `בדו”ח טבלאי, בחרו את אחת האפשרויות עבור השדה הנוכחי:
    שדה לציר” X (עמודות)” בחרו באפשרות זו עבור שדה שתרצו שהערכים שלו ישמשו כעמודות הדו”ח (קטגוריות). בדו”ח טבלאי חובה להגדיר את אחד השדות כ X.
   שדה מיון לציר X - בחרו באפשרות זו עבור שדה שתרצו למיין לפיו את עמודות הדו”ח.
   הערה: אם בחרתם באפשרות “שדה מיון לציר X”,
   וודאו ששדה זה נלקח מאותה רמת מסך (מסך אב/מסך בן) של “שדה לציר “X.`, //263
    expressionHelp: 'ExpresssionHelp', //75
    promoTitle: 'דו"חות חדשים עם Priority Analytics', //76
    promoContent: 'מוזמנים לבנות דו"חות בכלי Analytics חדש וליהנות מיכולות חזקות ואפשרויות מתקדמות', //77
    promoOkBtn: 'הבנתי', //78
    promoShowBtn: 'אני רוצה לראות', //79

    reportPageTitle: 'הגדרות הדו"ח', //80
    emptyStateFormSelect: 'לא מצאנו מסך מתאים. כדאי לבדוק את האיות ולנסות שוב', //81
    noMatchEmptyState: 'נראה שאין דו"חות מתאימים לחיפוש', //82
    noMatchEmptyState2: 'כדאי לשנות את האיות ולנסות שוב.', //83

    analyticsHelpTooltip: 'help', //84
    selected: '(X) שדות נבחרו', //85

    copyOf: 'עותק (X) של', //88

    validationMsgExpr:
        'The “Expression/format” field in the Expression column is empty, please fill it with a value',
    validationMsgWidth:
        'The Width value of one or more columns in the report is not been define. Please fill it with a value',
    validationMsgWidthAndExpr: 'Expression and Width values must be larger than zero and not empty',

    searchInput: 'Search',
    currentUser: 'אני',
    active: 'פעיל',
    onlyCompFieldError: 'only comp',
    typeColumn: 'סוג',
    reportType: 'דו"ח',
    widgetType: `וויג'ט`,
    chartType: 'תרשים',
    useAsDataset: 'מערך נתונים',
    dataset: '(מערך נתונים)',
    datasetHelp:
        'עזרה לתיבה dataset - סמנו תיבה זו כדי שתוכלו להשתמש בדו”ח זה לצורך אימון מודל חיזוי נתונים',
    chartPageTitle: 'הגדרות תרשים',
    subTitle: 'תת כותרת',
    xAxis: 'ציר X',
    yAxis: 'ציר Y',
    topXresults: 'תוצאות מובילות',
    report: 'טבלה',
    widget: "וידג'ט",
    chart: 'גרף',
    noMatchEmptyResults: 'נראה שאין תוצאות מתאימות לחיפוש',
    series: 'סדרה',
    category: 'קטגוריה',
    zBubbleSize: 'גודל בועה (Z)',
    topCategoryResults: 'קטגוריות מובילות',
    minimumX: 'מינימום X',
    minimumY: 'מינימום Y',
    maximumX: 'מקסימום X',
    maximumY: 'מקסימום Y',
    column2dInfo: `השתמשו בתרשים זה כדי להשוות ערכים שונים של כמה קטגוריות.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה הערכים עבור ציר Y\nבשדה "תוצאות מובילות" הגדירו את מספר הקטגוריות (עמודות) שתרצו לראות בתרשים.`,
    bar2dInfo: `השתמשו בתרשים זה כדי להשוות ערכים שונים של כמה קטגוריות.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה הערכים עבור ציר Y\nבשדה "תוצאות מובילות" הגדירו את מספר הקטגוריות (ברים) שתרצו לראות בתרשים.`,
    lineInfo:
        'השתמשו בתרשים זה כדי להציג מגמות בציר זמן או קטגוריות.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה ערכי המדידה עבור ציר X ואת שדה ערכי המדידה עבור ציר Y.\nבשדה "תוצאות מובילות" הגדירו את מספר הקטגוריות  שתרצו לראות בתרשים.',
    pie2dInfo:
        'השתמשו בתרשים זה כדי לצפות בהתפלוגות שיעורים שונים של קטגוריה מתוך השלם.\nהשתמשו בתרשים טבעת ולא בתרשים פאי כאשר קיימות כמה קטגוריות המרכיבות סכום גדול יותר.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה ערכי המדידה עבור ציר Y.\nבשדה מספר תוצאות מובילות הגדירו את מספר הקטגוריות שתרצו לראות בתרשים.',
    sparkwinlossInfo:
        'השתמשו בתרשים זה כדי להציג עליות וירידות בטרנדים או ביצועים כסימונים חיוביים או שליליים על הציר בתרשים.\nהערכים שנמצאים מעל הציר האופקי הם ערכים חיוביים (רווחים) והערכים שמוצגים מתחת לציר הם שליליים (הפסדים).\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה ערכי המדידה עבור ציר Y.\nבשדה "תוצאות מובילות" הגדירו את מספר הקטגוריות שתרצו לראות בתרשים.',
    pyramidInfo:
        'השתמשו בתרשים זה כדי להציג נתונים בצורה היררכית.\nכל מדרגה בפירמידה מייצגת סט נתונים או נושא אחר כאשר המדרגה הנמוכה ביותר מייצגת את סט הנתונים הרחב/בסיסי ביותר וככל שמתקדמים במעלה הפירמידה, סט הנתונים הופך להיות מצומצם יותר.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה ערכי המדידה עבור ציר Y.\nבשדה מספר תוצאות מובילות הגדירו את מספר הקטגוריות שתרצו לראות בתרשים.',
    bubbleInfo:
        'השתמשו בתרשים זה כדי להציג ערכים של סדרות שונות עם קשרי גומלין (בצורה יחסית) בפיזור על ציר X וציר Y.\nבחרו שדה עבור ציר X ואת שדה ערכי המדידה עבור ציר Y.\nעבור כל ציר אפשר להגדיר ערכי מינימום ומקסימום שיופיעו בתרשים.\nבשדה "קטגוריה" בחרו שדה המייצג את הקטגוריה של הבועות.\nבשדה "גודל בועה (Z)" בחרו שדה שהערך שלו יקבע את הגודל של הבועה.',
    angulargaugeInfo:
        'תרשים זה מציג טווח ערכים עם מחוג המצביע על תוצאת הערך הנמדד.\nטווח הערכים מחולק לקטעים בארבעה צבעי רמזור (לבן, ירוק, צהוב ואדום) המייצגים ערכים בסדר היררכי.\nקטעים אלו מוגדרים במסך "הגדרת מדדים", שם אפשר לקבוע את ערכי הטווחים של כל קטע.\nעבור הערך הנמדד, בחרו את השדה שהתוצאה שלו תסומן על ידי המחוג בתרשים.',
    kpiInfo:
        'ה- KPI מציג ערך מדיד המשמש להערכת ביצועים או פעילויות.\n עבור ערך KPI, בחרו את השדה המכיל את הערך שתרצו להציג.',
    mscolumn2dInfo:
        'השתמשו בתרשים זה כדי להשוות ערכים בכמה קטגוריות, מקובצים באשכולות (סדרות).\nבחרו שדה המייצג את הסדרה בתרשים. מומלץ להגדיר שדה זה כשדה קלט בלשונית “נתונים” ובהפקת התרשים לבחור עד 3 ערכים.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה הערכים עבור ציר Y.\nבשדה תוצאות מובילות הגדירו את מספר הקטגוריות (עמודות) שתרצו לראות בתרשים.',
    msbar2dInfo:
        'השתמשו בתרשים זה כדי להשוות ערכים בכמה קטגוריות, מקובצים באשכולות (סדרות).\nבחרו שדה המייצג את הסדרה בתרשים. מומלץ להגדיר שדה זה כשדה קלט בלשונית “נתונים” ובהפקת התרשים לבחור עד 3 ערכים.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה הערכים עבור ציר Y.\nבשדה תוצאות מובילות הגדירו את מספר הקטגוריות (ברים) שתרצו לראות בתרשים.',
    mslineInfo:
        'השתמשו בתרשים זה כדי להציג מגמות של כמה סדרות של נתונים רציפים כמו רווחים לתקופה.\nכל סדרה מיוצגת כקו נפרד המורכב ממספר נקודות כאשר כל נקודה מייצגת ערך.\nבהצגת כמה סדרות על אותו תרשים אפשר לבחון את הקשרים בין הסדרות.\nבחרו שדה המייצג את הסדרה בתרשים. מומלץ להגדיר שדה זה כשדה קלט בלשונית “נתונים” ובהפקת התרשים לבחור עד 3 ערכים.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה ערכי המדידה עבור ציר Y.\nבשדה "תוצאות מובילות" הגדירו את מספר הקטגוריות  שתרצו לראות בתרשים.',
    stackedcolumn2dInfo:
        'השתמשו בתרשים זה כדי להציג סדרות נתונים זו על גבי זו.\n בכל עמודה אפשר לראות את הגודל המצטבר של שתי סדרות נתונים או יותר. כל סדרת נתונים נבדלת על ידי צבע המקטע שלה בערימה.\nבחרו שדה המייצג את הסדרה בתרשים. מומלץ להגדיר שדה זה כשדה קלט בלשונית “נתונים” ובהפקת התרשים לבחור עד 3 ערכים.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה הערכים עבור ציר Y.\nבשדה "תוצאות מובילות" הגדירו את מספר הקטגוריות (עמודות) שתרצו לראות בתרשים.',
    stackedbar2dInfo:
        'השתמשו בתרשים זה כדי להציג סדרות נתונים זו על גבי זו.\n בכל עמודה אפשר לראות את הגודל המצטבר של שתי סדרות נתונים או יותר. כל סדרת נתונים נבדלת על ידי צבע המקטע שלה בערימה.\nבחרו שדה המייצג את הסדרה בתרשים. מומלץ להגדיר שדה זה כשדה קלט בלשונית “נתונים” ובהפקת התרשים לבחור עד 3 ערכים.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה הערכים עבור ציר Y.\nבשדה "תוצאות מובילות" הגדירו את מספר הקטגוריות (ברים) שתרצו לראות בתרשים.',
    doughnut2dInfo:
        'השתמשו בתרשים זה כדי לצפות בהתפלוגות שיעורים שונים של קטגוריה מתוך השלם.\nבחרו את שדה הקטגוריה עבור ציר X ואת שדה ערכי המדידה עבור ציר Y.\nבשדה מספר תוצאות מובילות הגדירו את מספר הקטגוריות  שתרצו לראות בתרשים.',
    enterNumber: 'נא להזין מספר',
    typeChart: 'גרף',
    typeWidget: 'רכיב',
    typeReport: 'דו"ח',
    TypeDataSet: 'מבנה נתונים',
    typeOldReport: 'דו"ח ישן',
    typeDataSet: 'מערך נתונים',
    chooseData: 'בחרו את הנתונים',
    chooseAxes: 'בחרו ערכים שונים עבור הצירים X ו-Y.',
    exit: 'יציאה',
    typeTabTitle: 'סוג',
    chooseChartType: 'בחרו סוג תרשים',
    chartName: 'כותרת התרשים',
    enterChartName: 'רשמו את כותרת התרשים',
    enterSubTitle: 'רשמו תת כותרת',
    explanatoryReport: 'דו”ח ביאורים',
    data: 'נתונים',
    axes: 'צירים',
    scale: 'סקאלה',
    baseValue: 'ערך התחלתי',
    endOfRedArea: 'סוף קטע אדום',
    endOfYellowArea: 'סוף קטע צהוב',
    endOfGreenArea: 'סוף קטע ירוק',
    endOfWhiteArea: 'סוף קטע לבן',
    column2dHeader: 'תרשים עמודות',
    bar2dHeader: 'תרשים ברים',
    lineHeader: 'תרשים קו',
    pie2dHeader: 'תרשים עוגה',
    doughnut2dHeader: 'תרשים טבעת',
    bubbleHeader: 'תרשים בועות',
    sparkwinlossHeader: 'תרשים רווח/הפסד',
    pyramidHeader: 'תרשים פירמידה',
    funnelHeader: 'תרשים משפך',
    stackedcolumn2dHeader: 'תרשים עמודות מצטברות',
    stackedbar2dHeader: 'תרשים ברים מצטברים',
    kpiHeader: 'KPI',
    angulargaugeHeader: 'מונה',
    mscolumn2dHeader: 'תרשים עמודות (ריבוי סדרות)',
    msbar2dHeader: 'תרשים ברים (ריבוי סדרות)',
    mslineHeader: 'תרשים קו (ריבוי סדרות)',
    columnChart: 'עמודות',
    barChart: 'עמודות אופקיות',
    msLineChart: 'קווים',
    pieChart: 'פאי',
    doughnutChart: 'טבעת',
    bubbleChart: 'פיזור - בועות',
    gaugeChart: 'ברומטר',
    winLossChart: 'רווח/הפסד',
    pyramidChart: 'פירמידה',
    funnelChart: 'משפך',
    kpiChart: 'כרטיסייה',
    stackedColumnChart: 'עמודות מצטברות',
    stackedBarChart: 'עמודות אופקיות מצטברות',
    singleSeriesCharts: 'תרשים - סדרה בודדת',
    multiSeriesCharts: 'תרשים - ריבוי סדרות',
    msBarChart: 'עמודות אופקיות',
    chooseCategory: 'בחרו קטגוריה',
    axesIn: 'צירים ב',
    availableFields: 'שדות אפשריים',
    xAxisCategory: 'ציר X (קטגוריה)',
    yAxisMeasure: 'ציר Y (ערכי מדידה)',
    kpiValue: 'ערך KPI',
    measuredValue: 'ערך נמדד',
    enterChartDimensions: 'הגדרת מימדי התרשים',
    multiSeries: 'ריבוי סדרות',
    singleSeries: 'סדרה בודדת',
    saveTooltip: 'הגדירו את כל שדות החובה',
    explanatoryReportHelp: 'בחרו דו”ח מהרשימה שישמש כדו”ח ביאורים לתוצאות התרשים.',
    chooseFromList: 'בחרו מהרשימה',
    enterValue: 'רשמו ערך',
    hideEye: 'לחצו כדי להסתיר את השדה. אפשר להשתמש בשדה זה עבור ביטויים, נוסחאות או כשדה קלט.',
    fieldsTableFormat: 'פוּרמָט',
    fieldsTableShowMine: 'תראה את שלי',
    advancedSettings: 'הגדרות מתקדמות',
    revertTooltip: 'חזרה ל',
    addExpression: 'הוספית ביטוי',
    formatHelp: ` לשדה.
    \n
    רשימת הבחירה משתנה בהתאם לסוג השדה.
    \n
    רשימת הבחירה עבור שדות נומריים מוגדרת במסך
     הגדרת פורמט מספרים ל”- Analytics”`,
    showMineHelp: ' סמנו את התיבה אם תרצו לראות רק נתונים מתעודות המוגדרות לטיפולכם.',
    helpFunctionsDialog: `
    כאן תוכלו להוסיף שדה חישובי מותאם אישית. תוכלו להתבסס על שדות מהרשימה, ולהשתמש בפעולות (פונקציות), ולבצע חישובים מתמטיים.`,
    titleFunctionsDialog: 'הוסף ביטוי',
    xAxisItem: 'שדה לציר X (עמודות)',
    oAxisItem: 'שדה מיון לציר X',
    addToMenu: 'הוסף לתפריט',
    chooseReportsMenuTitle: 'בחר דוח עבור תפריט',
    addUserDefined: '“הוספת דו”ח משתמש” ',
    helpDefinedReport:
        ' סמנו את הדו”ח שתרצו להוסיף לתפריט הנבחר. תוכלו להשתמש בחיפוש החופשי כדי לאתר את הדו”ח המבוקש. ',
    close: 'סגירה',
    youChose: 'בחרת בדו”ח: X',
    labelSelect: 'עדיין לא בחרת דו”ח.',
    search: '“התחילו לחפש כאן”',
    emptyResult: `
    לא מצאנו דו”ח שמתאים לחיפוש שלך.

    אפשר לנסות חיפוש אחר.`,
    toastText: 'הדו”ח X נוסף בהצלחה לתפריט Y',
    no_options_text: 'אין תוצאות',
    clearAll: 'נקה הכל',
    appliedFilters: 'החלת מסננים',
    OldGenerator: 'מחולל ישן',

    barAndColTooltip: 'השתמשו בתרשים זה כדי להשוות ערכים בין כמה קטגוריות.',
    lineTooltip: 'השתמשו בתרשים זה כדי להציג מגמות לאורך זמן, או בהתאם לקטגוריות בעלות סדר.',
    pieAndDoughnutTooltip: 'השתמשו בתרשים זה כדי להציג התפלגות שיעורים מתוך שלם.',
    bubbleTooltip: 'השתמשו בתרשים זה כדי להשוות בין כמה סדרות של נתונים ולהציג את היחסים ביניהם.',
    gaugeTooltip: 'השתמשו בתרשים זה כדי להציג נתון מסוים על פני סולם ערכים.',
    pyramidTooltip: 'השתמשו בתרשים זה כדי להציג נתונים בצורה היררכית.',
    kpiTooltip: 'השתמשו בכרטיסייה כדי להציג ערך בודד שמעניק לכם מידע על ביצועים או פעילויות.',

    multiColAndBarTooltip:
        'השתמשו בתרשים זה כדי להשוות ערכים בין כמה קטגוריות המקובצות לפי קטגוריה ראשית, ומפורטות לפי קטגוריה משנית.',
    multiLineTooltip:
        'השתמשו בתרשים זה כדי להציג מגמות לאורך זמן של קטגוריות המקובצות לפי קטגוריה ראשית, ומפורטות לפי קטגוריה משנית.',
    multiStackedColumnTooltip:
        'השתמשו בתרשים זה כדי להשוות ערכים בין כמה קטגוריות המקובצות לפי קטגוריה ראשית, ומחולקות לפי קטגוריה משנית.',
    funnelTooltip: 'השתמשו בתרשים זה כדי להציג שלבים הולכים וקטנים בתהליך.',
    lineChart: 'קו',
    msColumnsChart: 'עמודות',
    commonXAxisPlaceHoder: 'שדה הקטגוריה',
    commonYAxisPlaceHoder: 'שדה הערכים',
    pieCategoryPlaceHolder: 'שדה שקובע את חלקי הפאי',
    doughnutCategoryPlaceHolder: 'שדה שקובע את חלקי הטבעת',
    valuesPlaceHolder: 'שדה שקובע את גודל החלקים',
    bubbleXAxisPlaceHoder: 'שדה ערכים לציר X',
    bubbleXAxisStartRange: 'ציר X יתחיל מערך זה',
    bubbleXAxisEndRange: 'ציר X יסתיים בערך זה',
    bubbleYAxisPlaceHoder: 'שדה הערכים לציר Y',
    bubbleYAxisStartRange: 'ציר Y יתחיל מערך זה',
    bubbleYAxisEndRange: 'ציר Y יסתיים בערך זה',
    bubbleCategoryPlaceHolder: 'שדה לנושא הבועה',
    bubbleSizePlaceHolder: 'שדה ערכים לגודל הבועות',
    gaugeScalePlaceHolder: 'סרגל הערכים למדידה',
    gaugeMeasuredValuePlaceHolder: 'שדה שמכיל את הערך הנמדד',
    cardValuePlaceHolder: 'שדה שמכיל את הערך להצגה',
    msPrimaryXAxisPlaceHolder: 'שדה הקטגוריה הראשית',
    msSecondaryXAxisPlaceHolder: 'שדה הקטגוריה המשנית',
    msYAxisPlaceHolder: 'שדה הערכים',
    singleSeriesTopXHelp:
        'רשמו כאן את כמות התוצאות שתרצו לראות בתרשים.\nהתוצאות שיופיעו הן מספר התוצאות הראשונות לפי הסדר שלהן בנתונים.\nכדי לא להעמיס על נראות התרשים, ברירת המחדל היא 10 תוצאות ואפשר לשנות אותה ידנית בשדה זה.',
    multiSeriesTopXHelp:
        'רשמו כאן את כמות התוצאות שתרצו לראות בתרשים.\nהתוצאות שיופיעו הן מספר התוצאות הראשונות לפי הסדר שלהן בנתונים.\nכדי לא להעמיס על נראות התרשים, ברירת המחדל היא 3 תוצאות ואפשר לשנות אותה ידנית בשדה זה.',
    scaleChartHelp:
        'בחרו מהרשימה את סולם המדידה המתאים לנתון שמודדים בתרשים זה.\n סולמות המדידה המופיעים כאן מוגדרים במסך ואפשר ליצור שם סולם חדש בהתאם לצרכי תרשים זה.\nלאחר בחירת הסולם, צבעי המקטעים יתמלאו בהתאם להגדרות הסולם.',
    pyramidCategoryPlaceHolder: 'שדה שקובע את חלקי הפירמידה',
    funnelCategoryPlaceHolder: 'שדה שקובע את חלקי משפך',
    typeTabTitleStep: 'שלב 1: סוג',
    dataStep: 'שלב 2: נתונים',
    axesStep: 'שלב 3: מימדים',
    nextStepTitle: 'השלב הבא…',
    nextStepMessage: 'אחר שבחרתם סוג תרשים, לחצו על "שלב 2: נתונים" כדי להמשיך.',
    maximum: 'מקסימום',
    minimum: 'מינימום',
    convertDecimal: 'המרה לעשרוני',
    roundToWhole: 'עיגול לשלם',
    absoluteValueInt: 'ערך מוחלט - מספר שלם',
    absoluteValueReal: 'ערך מוחלט - מספר עשרוני',
    dataInclusion: 'נתונים כלולים',
    dataInclusionHelp:
        'כאן תוכלו לקבוע שנתונים ממסך אב תמיד יוצגו גם כאשר לא קיימים נתונים במסך בן.\nאפשר לבחור מסך בן אחד בלבד.',
    oneSubformRestriction: 'אפשר לבחור מסך בן אחד בלבד.',
    calcFormsTooltip: 'מסכים מחושבים לא נתמכים כרגע ב- Priority Analytics'
};

const en = {
    advancedSettings: 'Advanced Settings',
    myReports: 'My Reports',
    exitForm: 'Exit form',
    reportName: 'Report Name',
    baseForm: 'Base Form',
    createdOn: 'Created On',
    createdBy: 'Created By',
    updated: 'Updated',
    shared: 'Shared',
    share: 'Share',
    edit: 'Edit',
    run: 'Run',
    duplicate: 'Duplicate',
    delete: 'Delete',
    deleteMsg: 'Are you sure tou want delete this report?',
    newReport: 'New Report',
    formSelectHelp: 'Choose the type of report you want to create, and then choose a base form',
    selectBaseForm: 'Select Base Form',
    selectFormPlaceHolder: 'Select from the list',
    ok: 'OK',
    cancel: 'Cancel',
    save: 'Save',
    runReport: 'Run Report',
    runChart: 'Run Chart',
    baseFormLabel: 'Base form',
    reportNameLabel: 'Enter report name',
    multiCheckBox: 'Multi company?',
    tabularCheckBox: 'Tabular Report?',
    addFieldBtn: 'Add Fields',
    addExpressBtn: 'Add expression',
    selectFieldTitle: 'Select Fields',
    selectFieldHelp: 'Select field help',
    exitNoSave: 'Exit without saving your changes?',
    //31 -
    yes: 'Yes',
    no: 'No',
    fieldsTableName: 'Name',
    fieldsTableId: 'ID',
    fieldsTableNewName: 'New Name In Report',
    fieldsTableWidth: 'Width',
    fieldsTableInput: 'Input',
    fieldsTableGroup: 'Group',
    fieldsTableGroupTitle: 'Group in Title',
    fieldsTablegroupFunction: 'Group Function',
    fieldsTableRepeatValue: 'Repeat value',
    fieldsTablegroupNone: 'None',
    fieldsTableGroupFunctionHelp: 'Help',
    reportListType: 'Type',
    fieldsTableGroupTotalOnly: 'Group Total',
    fieldsTableReportTotalOnly: 'Report Total',
    fieldsTableTotalBoth: 'Both',
    fieldsTableGroupMain: 'Main',
    fieldsTableGroupSecondary: 'Secondary:',
    fieldsTableHidden: 'Hidden',
    fieldsTableSort: 'Sort',
    fieldsTableFunction: 'Function',
    fieldsTableFunctionSum: 'Sum',
    fieldsTableFunctionAvg: 'Avg',
    fieldsTableFunctionMax: 'Max',
    fieldsTableFunctionMin: 'Min',

    fieldsTableXaxis: 'xAxis',
    fieldsTableExp: 'Expression/Format',
    deleteField: 'Delete',
    companyName: 'Company Name', //52
    expression: 'Expression', //53
    analyticsToolTip: 'Priority Analytics', //54
    analyticsHelp:
        'With advanced analytics tools you can easily create reports personalised to your business needs.\nUsing innovative technology, build reports that include combined data from different areas in the system, helping you analyse and evaluate information to make data-driven decisions.\nTo create a report, click the New Report button, and choose the fields from a variety of forms you want to appear in the report.\nSee your saved reports in the My Reports area, where you can reuse them and share them with other users.\n\nFor more information, see Priority Xpert.',
    oldGenToolTip: 'This reports was created via old Reports generator', //56
    oldGenEditToolTip: 'You can still edit the report in the original reportgenerator.', //57
    emptyStateTitle: 'Create personalized reports', //58
    emptyStateSubTitle: 'Once you create reports they will show here', //59
    newReportBtn: 'New Report', //60
    analyticsReportHelp:
        'Here you can define report settings: Name the report, share the report, define the report as multi-company, and choose fields for the report. You can also set report column definitions: Sort and group data, aggregate mathematical calculations, and add personalised Expression columns for additional calculations.\n See Priority Xpert more for information.',
    analyticsChartHelp:
        'Use this form to define the type of chart and chart data for your report.\n\nIn the form header, define general settings for your chart, like the chart name, and whether to make the report shareable.\n\nThen use the tabs to define more settings:\n\n- In the Type tab choose the type of chart.\n\nIn the Data tab define the fields and report column definitions: Sort and group data, aggregate mathematical calculations, and add personalised Expression columns for additional calculations.\n\n- In the Dimensions tab, define the fields to be used as the X and Y axis, or other dimensions in the chart.\n\nSee Priority Xpert more for information.',
    sharedHelp: 'help', //62
    multiCompanyHelp: 'help', //63
    tabularHelp:
        ' Mark this checkbox to create a report using selected field values as the report categories, displayed as the report column headers (X axis).', //64
    idNumberHelp: 'id number help', //65
    nameInReportHelp: 'name in report help', //66
    widthHelp: 'width help', //67
    inputHelp: 'input help', //68
    groupHelp: 'group help', //69
    groupTitle: 'group title help', //70
    hiddenHelp: 'hidden help', //71
    sortHelp: 'Sort help', //72
    sortDirection: 'Choose to sort in ascending or descending order.',
    functionHelp: 'function help', //73
    axisHelp: `In a tabular report, choose an option from the drop-down list:
    X axis field - By choosing this option, you define the current field as the columns of the report (categories). In a tabular report, you must define one field as an “X axis field”.
    Sort field for X axis - Choose this option for a field by which you want to set the order of column appearance in the report.
   Note: If you choose the option “Sort field for X axis” for a certain field, make sure this field is in the same form level as the “X axis field”, e.g., both fields are from an upper-level form.`, //263
    expressionHelp: 'ExpresssionHelp', //75
    promoTitle: 'New Reports with Priority Analytics', //76
    promoContent: 'Build reports with the new Analytics tool', //77
    promoOkBtn: 'OK, got it', //78
    promoShowBtn: '"Show me', //79

    reportPageTitle: 'Report Setting', //80
    emptyStateFormSelect: 'not found', //81
    noMatchEmptyState: 'It seems that no reports match your search.', //82
    noMatchEmptyState2: 'Check your spelling and try again', //83
    analyticsHelpTooltip: 'help', //84
    selected: 'Selected (X)', //85

    copyOf: 'Copy (X) of', //88

    validationMsgExpr:
        'The “Expression/format” field in the Expression column is empty, please fill it with a value',
    validationMsgWidth:
        'The Width value of one or more columns in the report is not been define. Please fill it with a value',
    validationMsgWidthAndExpr: 'Expression and Width values must be larger than zero and not empty',

    searchInput: 'Search',
    currentUser: 'Me',
    active: 'Active',
    onlyCompFieldError: 'only comp',
    typeColumn: 'Type',
    reportType: 'Report',
    widgetType: 'Widget',
    chartType: 'Chart',
    useAsDataset: 'Use as Dataset',
    dataset: '(Dataset)',
    datasetHelp:
        'Mark this checkbox so that you will be able to use the report for training the data forecast model',
    chartPageTitle: 'Chart Setting',
    chartName: 'Chart Name',
    enterChartName: 'Enter a chart name',
    enterSubTitle: 'Enter a sub title',
    exit: 'Exit',
    typeTabTitle: 'Type',
    chooseChartType: 'Choose chart type',
    chooseData: 'Choose chart data',
    chooseAxes: 'Choose X and Y Axes',
    xAxis: 'X Axis',
    yAxis: 'Y Axis',
    topXresults: 'Top X Results',
    report: 'Table',
    widget: 'Widget',
    chart: 'Chart',
    noMatchEmptyResults: 'It seems that no results match your search.',
    series: 'Series',
    category: 'Category',
    zBubbleSize: 'Z Bubble Size',
    topCategoryResults: 'Top Category Results',
    minimumX: 'minimum X',
    minimumY: 'minimum Y',
    maximumX: 'maximum X',
    maximumY: 'maximum Y',
    column2dInfo:
        'Use the column chart type to visually compare values across different categories.\nChoose the category field for Axis X and the value field for Axis Y.\nFill in the Top Results field with the number of categories (columns) you want to see.',
    bar2dInfo:
        'Use the column chart type to visually compare values across different categories.\nChoose the category field for Axis X and the value field for Axis Y.\nFill in the Top Results field with the number of categories (bars) you want to see.',
    lineInfo:
        'Use this line chart to show patterns over time, (e.g., years or months), or categories.\n Choose the category you want to measure for Axis X, and the measurement value field for Axis Y.\nFill in the Top Results field with the number of categories you want to see.',
    pie2dInfo:
        'Use the doughnut chart to show proportions of a whole.\nUse it instead of a pie chart when there are multiple series that relate to a larger sum.\nChoose the category you want to measure for Axis X, and the measurement value field for Axis Y.\nFill in the Top Results field with the number of categories you want to see.',
    sparkwinlossInfo:
        'Use this chart to show the ups and downs in trends/performances as positive/negative values.\nThe values above the horizontal axis show positive values (win). The values under the axis show the negative values (loss).\nChoose the category you want to measure for Axis X, and the measurement value field for Axis Y.\nFill in the Top Results field with the number of categories you want to see.',
    pyramidInfo:
        'Use this chart to compare data in a hierarchy consisting of various segments or steps in ascending or descending order.\nChoose the category you want to measure for Axis X, and the measurement value field for Axis Y.\nFill in the Top Results field with the number of categories you want to see.',
    bubbleInfo:
        'Use the bubble chart to show the relationship between sets of values.\nChoose a field for Axis X, and the measurement value field for Axis Y.\nFor each axis, you can choose minimum and maximum values that will appear in the chart.\nIn the Category field, choose a field to represent the category of the bubbles.\nIn the Bubble Size (Z) field, choose a field that determines the size of the bubble.',
    angulargaugeInfo:
        'Use this chart to show a range of values, in which a needle is used to indicate the result of the Y value.\nThe range of values is divided into 4 areas in 4 different colours: white, green, yellow and red), that represent the values in hierarchical order.\nThese sections are defined in the Definition of Gauge Scales form, where you can define the values of each area.\nFor the Measured Value, choose the field for which the needle will mark the result in the chart.',
    kpiInfo:
        'Use KPI charts to evaluate the current value and status of a metric against a defined target.\n For the KPI Value, choose the field that represents the value you want to show.',
    mscolumn2dInfo:
        'Use this chart to compare values of several categories, grouped into clusters (series).\nChoose a field to represent the series in the chart. We recommend defining this field as an input parameter in the Data tab, and when you generate the chart, choose up to 3 values.\nChoose the category field for Axis X, and the value field for Axis Y.\nFill in the Top Results field with the number of categories (columns) you want to see in the chart.',
    msbar2dInfo:
        'Use this chart to compare values of several categories, grouped into clusters (series).\nChoose a field to represent the series in the chart. We recommend defining this field as an input parameter in the Data tab, and when you generate the chart, choose up to 3 values.\nChoose the category field for Axis X, and the value field for Axis Y.\nFill in the Top Results field with the number of categories (bars) you want to see in the chart.',
    mslineInfo:
        'Use this chart to show trends in multiple series, for continuous data like earnings per quarter.\nEach series is represented by a line made up of several data points, and each point represents a value.\nSeveral series that appear on the same chart show the relationship between the series.\nChoose a field to represent the series in the chart. We recommend defining this field as an input parameter in the Data tab, and when you generate the chart, choose up to 3 values.\nChoose the category field for Axis X, and the measurement value field for Axis Y.\nFill in the Top Results field with the number of categories you want to see in the chart.',
    stackedcolumn2dInfo:
        'Use this chart to show the value of two or more data series, where datasets are placed on top of each other. In each column you can see the cumulative value of the data series. Each data series appears in a different colour in the stack.\nChoose a field to represent the series in the chart. We recommend defining this field as an input parameter in the Data tab, and when you generate the chart, choose up to 3 values.\nChoose the category field for Axis X, and the value field for Axis Y.\nFill in the Top Results field with the number of categories (columns) you want to see in the chart.',
    stackedbar2dInfo:
        'Use this chart to show the value of two or more data series, where datasets are placed on top of each other. In each column you can see the cumulative value of the data series. Each data series appears in a different colour in the stack.\nChoose a field to represent the series in the chart. We recommend defining this field as an input parameter in the Data tab, and when you generate the chart, choose up to 3 values.\nChoose the category field for Axis X, and the value field for Axis Y.\nFill in the Top Results field with the number of categories (bars) you want to see in the chart.',
    doughnut2dInfo:
        'Use the pie chart to show proportions of a whole.\nChoose the category you want to measure for Axis X, and the measurement value field for Axis Y.\nFill in the Top Results field with the number of categories you want to see.',
    enterNumber: 'Enter a number',
    typeChart: 'Chart',
    typeWidget: 'Widget',
    typeReport: 'Report',
    TypeDataSet: 'DataSet',
    typeDataSet: 'Dataset',
    typeOldReport: 'Old Report',
    explanatoryReport: 'Explanatory Report',
    subTitle: 'Chart Subtitle',
    data: 'Data',
    axes: 'Axes',
    scale: 'Scale',
    baseValue: 'Base Value',
    endOfRedArea: 'End of red area',
    endOfYellowArea: 'End of yellow area',
    endOfGreenArea: 'End of green area',
    endOfWhiteArea: 'End of white area',
    column2dHeader: 'Column Chart',
    bar2dHeader: 'Bar Chart',
    lineHeader: 'Line Chart',
    pie2dHeader: 'Pie Chart',
    doughnut2dHeader: 'Doughnut Chart',
    bubbleHeader: 'Bubble Chart',
    sparkwinlossHeader: 'Sparkline (Win/Loss) Chart',
    pyramidHeader: 'Pyramid Chart',
    funnelHeader: 'Funnel Chart',
    stackedcolumn2dHeader: 'Stacked Column Chart',
    stackedbar2dHeader: 'Stacked Bar Chart',
    kpiHeader: 'KPI',
    angulargaugeHeader: 'Gauge',
    mscolumn2dHeader: 'Column Chart (Multi-Series)',
    msbar2dHeader: 'Bar Chart (Multi-Series)',
    mslineHeader: 'Line Chart (Multi-Series)',
    columnChart: 'Column',
    barChart: 'Horizontal Column',
    msLineChart: 'Lines',
    pieChart: 'Pie',
    doughnutChart: 'Doughnut',
    bubbleChart: 'Scatter Plot - Bubble',
    gaugeChart: 'Gauge',
    winLossChart: 'Spark Win/Loss',
    pyramidChart: 'Pyramid',
    funnelChart: 'Funnel',
    kpiChart: 'KPI Card',
    stackedColumnChart: 'Stacked Column',
    stackedBarChart: 'Horizontal Stacked Columns',
    singleSeriesCharts: 'Single-Series Charts',
    multiSeriesCharts: 'Multi-Series Charts',
    msBarChart: 'Horizontal Columns',
    chooseCategory: 'Choose Category',
    axesIn: 'Axes in',
    availableFields: 'Available Fields',
    xAxisCategory: 'X Axis (Category)',
    yAxisMeasure: 'Y Axis (Measurement Values)',
    kpiValue: 'KPI Value',
    measuredValue: 'Measured Value',
    enterChartDimensions: 'Enter chart dimensions:',
    multiSeries: 'Multi-Series',
    singleSeries: 'Single-Series',
    saveTooltip: 'Fill in mandatory fields',
    explanatoryReportHelp: 'Choose a report from the list to use as an explanatory',
    chooseFromList: 'Select…',
    enterValue: 'Enter a value...',
    hideEye:
        'Click to hide the field. You can use the field in an expression, function, or as an input field.',
    fieldsTableFormat: 'Format',
    fieldsTableShowMine: 'Show mine',
    revertTooltip: 'Revert to',
    addExpression: 'Add Expression',
    formatHelp: `Enter a format for the field.
    \n
    The drop-down list changes according to the type of field.
    \n
    The list of numeric fields are based on the Define Number Format - Analytics form.`,
    showMineHelp:
        'Mark this checkbox so the report only shows data from documents assigned to the current user.',
    helpFunctionsDialog: `
        Here you can add a personalized calculated field.
        \n
        You can base it on a field from the list, add functions, and perform a mathematical calculation.`,
    titleFunctionsDialog: 'Add expression',
    xAxisItem: 'X axis field',
    oAxisItem: 'Sort field for X axis',
    addToMenu: 'Add to menu',
    chooseReportsMenuTitle: 'Choose Report for menu',
    addUserDefined: 'Add User-Defined Report',
    helpDefinedReport:
        'Choose a report to add to your Priority menu. You can use the search box to easily find a report.',
    close: 'Close',
    youChose: 'You chose: X',
    labelSelect: 'You have not yet selected a report.',
    search: 'Search…',
    emptyResult: `We did not find results for your search. \n Check your spelling and try again.`,
    toastText: 'The X report was added to the Y menu.',
    no_options_text: 'We did not find results for your search.',
    clearAll: 'Clear all',
    appliedFilters: 'Applied filters',
    OldGenerator: 'Old generator',

    barAndColTooltip: 'Use this chart to compare values between categories. ',
    lineTooltip: 'Use this chart to show trends over time, or according to ordered categories.',
    pieAndDoughnutTooltip: 'Use this chart to show the division of the whole into parts.',
    bubbleTooltip:
        'Use this chart to compare several series of data and show the relationship between them.',
    gaugeTooltip: 'Use this chart to show specific data across a range of values.',
    pyramidTooltip: 'Use this chart to show data in a hierarchical manner.',
    kpiTooltip:
        'Use the card to show a single value that gives you information on performance or activity.',
    multiColAndBarTooltip:
        'Use this chart to compare values between several categories grouped by a main category, and detailed by a secondary category.',
    multiLineTooltip:
        'Use this chart to show trends over time of categories grouped by a main category, and detailed by a secondary category.',
    multiStackedColumnTooltip:
        'Use this chart to compare values between several categories grouped by a main category, and divided by a secondary category.',
    funnelTooltip: 'Use this chart to show stages of a process as they narrow.',
    lineChart: 'Line',
    msColumnsChart: 'Columns',
    commonXAxisPlaceHoder: 'Category field',
    commonYAxisPlaceHoder: 'Value field',
    pieCategoryPlaceHolder: 'Field that determines pie slices',
    doughnutCategoryPlaceHolder: 'Field that determines parts of the doughnut',
    valuesPlaceHolder: 'Field that determines size of the parts',
    bubbleXAxisPlaceHoder: 'Value field for X axis',
    bubbleXAxisStartRange: 'X axis starts from this value',
    bubbleXAxisEndRange: 'X axis ends with this value',
    bubbleYAxisPlaceHoder: 'Value field for Y axis',
    bubbleYAxisStartRange: 'Y axis starts with this value',
    bubbleYAxisEndRange: 'Y axis ends with this value',
    bubbleCategoryPlaceHolder: 'Subject field of the bubble',
    bubbleSizePlaceHolder: 'Values field for bubble size',
    gaugeScalePlaceHolder: 'Range of values to measure',
    gaugeMeasuredValuePlaceHolder: 'Field with the measured value',
    cardValuePlaceHolder: 'Field that includes value to show',
    msPrimaryXAxisPlaceHolder: 'Main category field',
    msSecondaryXAxisPlaceHolder: 'Secondary value field',
    msYAxisPlaceHolder: 'Value field',
    singleSeriesTopXHelp:
        'Enter the number of results you want to show in the chart.\nThe results that appear are the top number of results according to their order in the data.\nAs not to overload the visibility of the chart, the default is 10 results, but you can change it manually in this field.',
    multiSeriesTopXHelp:
        'Enter the number of results you want to show in the chart.\nThe results that appear are the top number of results according to their order in the data.\nAs not to overload the visibility of the chart, the default is 3 results, but you can change it manually in this field.',
    scaleChartHelp:
        'Choose the relevant scale for the data you want to measure in this chart.\nThe scales that appear here are defined in the form, and you can create new scales there according to the needs of the charts.\nAfter you choose a scale, the colours will fill in according to the scale definitions.',
    pyramidCategoryPlaceHolder: 'Field that determines the pyramid segments',
    funnelCategoryPlaceHolder: 'Field that determines the funnel stages',
    typeTabTitleStep: 'Step 1: Type',
    dataStep: 'Step 2: Data',
    axesStep: 'Step 3: Dimensions',
    nextStepTitle: 'Next step…',
    nextStepMessage: 'You selected a chart type. Click on Step 2: Data to continue.',
    maximum: 'Maximum',
    minimum: 'Minimum',
    convertDecimal: 'Convert to decimal',
    roundToWhole: 'Round to whole',
    absoluteValueInt: 'Absolute value - integer',
    absoluteValueReal: 'Absolute value - real number',
    dataInclusion: 'Data Inclusion',
    dataInclusionHelp:
        'Here you can define that data from an upper-level form will always appear in the report, whether or not data exists in the subform.\nChoose one subform only.',
    oneSubformRestriction: 'Choose one subform only.',
    calcFormsTooltip: 'Calculated forms are not currently supported in Priority Analytics.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'myReports',
    2: 'exitForm',
    3: 'reportName',
    4: 'baseForm',
    5: 'createdOn',
    6: 'createdBy',
    7: 'updated',
    8: 'shared',
    9: 'edit',
    10: 'run',
    11: 'duplicate',
    12: 'delete',
    13: 'deleteMsg',
    14: 'newReport',
    16: 'selectBaseForm',
    17: 'selectFormPlaceHolder',
    18: 'ok',
    19: 'cancel',
    146: 'save',
    21: 'runReport',
    22: 'baseFormLabel',
    23: 'reportNameLabel',
    24: 'multiCheckBox',
    25: 'tabularCheckBox',
    26: 'addFieldBtn',
    27: 'addExpressBtn',
    28: 'selectFieldTitle',
    29: 'selectFieldHelp',
    145: 'exitNoSave',
    31: 'yes',
    32: 'no',
    33: 'fieldsTableName',
    34: 'fieldsTableId',
    35: 'fieldsTableNewName',
    36: 'fieldsTableWidth',
    37: 'fieldsTableInput',
    38: 'fieldsTableGroup',
    39: 'fieldsTableGroupTitle',
    40: 'fieldsTableGroupMain',
    41: 'fieldsTableGroupSecondary',
    42: 'fieldsTableHidden',
    43: 'fieldsTableSort',
    44: 'fieldsTableFunction',
    45: 'fieldsTableFunctionSum',
    46: 'fieldsTableFunctionAvg',
    47: 'fieldsTableFunctionMax',
    48: 'fieldsTableFunctionMin',
    49: 'fieldsTableXaxis',
    50: 'fieldsTableExp',
    51: 'deleteField',
    52: 'companyName',
    53: 'expression',
    54: 'analyticsToolTip',
    55: 'analyticsHelp',

    56: 'oldGenToolTip',
    57: 'oldGenEditToolTip',
    58: 'emptyStateTitle',
    59: 'emptyStateSubTitle',
    60: 'newReportBtn',
    61: 'analyticsReportHelp',
    62: 'sharedHelp',
    63: 'multiCompanyHelp',

    65: 'idNumberHelp',
    66: 'nameInReportHelp',
    67: 'widthHelp',
    68: 'inputHelp',
    69: 'groupHelp',
    70: 'groupTitle',
    71: 'hiddenHelp',
    72: 'sortHelp',
    73: 'functionHelp',

    75: 'expressionHelp',
    76: 'promoTitle',
    77: 'promoContent',
    78: 'promoOkBtn',
    79: 'promoShowBtn',
    80: 'reportPageTitle',
    81: 'emptyStateFormSelect',
    82: 'noMatchEmptyState',
    83: 'noMatchEmptyState2',
    84: 'analyticsHelpTooltip',
    85: 'selected',
    86: 'searchInput',
    87: 'currentUser',
    88: 'copyOf',
    91: 'validationMsgExpr',
    92: 'validationMsgWidth',
    93: 'validationMsgWidthAndExpr',
    94: 'active',
    96: 'onlyCompFieldError',
    97: 'typeColumn',
    100: 'chartType',
    101: 'useAsDataset',
    102: 'dataset',
    103: 'datasetHelp',
    104: 'typeDataSet',
    105: 'typeOldReport',
    106: 'fieldsTablegroupNone',
    107: 'fieldsTableGroupTotalOnly',
    108: 'fieldsTableReportTotalOnly',
    109: 'fieldsTableTotalBoth',
    110: 'fieldsTableGroupFunctionHelp',
    111: 'fieldsTablegroupFunction',
    112: 'fieldsTableRepeatValue',
    120: 'reportListType',
    122: 'report',
    123: 'chart',
    124: 'widget',
    125: 'formSelectHelp',
    126: 'help',
    127: 'ok',
    128: 'selectTypeAndBaseForm',
    129: 'chartPageTitle',
    131: 'chartName',
    132: 'enterChartName',
    133: 'subTitle',
    134: 'enterSubTitle',
    135: 'explanatoryReport',
    136: 'explanatoryReportHelp',
    137: 'chooseFromList',
    138: 'active',
    139: 'activeHelp',
    140: 'share',
    141: 'shareHelp',
    142: 'analyticsChartHelp',
    143: 'analyticsHelpTooltipReport',
    147: 'saveTooltip',
    148: 'runReport',
    149: 'exit',
    150: 'typeTabTitle',
    151: 'chooseChartType',
    152: 'singleSeriesCharts',
    153: 'multiSeriesCharts',
    154: 'msBarChart',
    155: 'barChart',
    156: 'msLineChart',
    157: 'pieChart',
    158: 'doughnutChart',
    159: 'bubbleChart',
    160: 'gaugeChart',
    161: 'winLossChart',
    162: 'pyramidChart',
    163: 'funnelChart',
    164: 'kpiChart',
    165: 'stackedColumnChart',
    166: 'stackedBarChart',
    167: 'data',
    168: 'chooseData',
    169: 'multiCompany',
    170: 'multiCompanyHelp',
    171: 'axes',
    172: 'xAxis',
    173: 'xAxisHelp',
    174: 'chooseFromList',
    175: 'chooseAxes',
    176: 'yAxis',
    177: 'yAxisHelp',
    178: 'topXresults',
    179: 'chooseTopXHelp',
    180: 'minValue',
    181: 'minAxisValue',
    182: 'enterMinValue',
    183: 'maxValue',
    184: 'maxAxisValue',
    185: 'enterMaxValue',
    186: 'scale',
    187: 'gaugeRange',
    188: 'series',
    189: 'chooseCompareFields',
    190: 'chooseFromList',
    191: 'chooseDifferentSeries',
    192: 'column2dInfo',
    193: 'bar2dInfo',
    194: 'lineInfo',
    195: 'pie2dInfo',
    196: 'sparkwinlossInfo',
    197: 'pyramidInfo',
    199: 'bubbleInfo',
    200: 'angulargaugeInfo',
    201: 'kpiInfo',
    202: 'mscolumn2dInfo',
    203: 'msbar2dInfo',
    204: 'mslineInfo',
    205: 'stackedcolumn2dInfo',
    206: 'stackedbar2dInfo',
    207: 'doughnut2dInfo',
    208: 'enterNumber',
    209: 'mscolumn2dHeader',
    210: 'msbar2dHeader',
    211: 'mslineHeader',
    212: 'category',
    213: 'zBubbleSize',
    214: 'topCategoryResults',
    215: 'minimumX',
    216: 'maximumX',
    217: 'minimumY',
    218: 'maximumY',
    219: 'xAxisCategory',
    220: 'yAxisMeasure',
    221: 'kpiValue',
    222: 'measuredValue',
    223: 'baseValue',
    224: 'endOfRedArea',
    225: 'endOfYellowArea',
    226: 'endOfGreenArea',
    227: 'endOfWhiteArea',
    228: 'column2dHeader',
    229: 'bar2dHeader',
    230: 'lineHeader',
    231: 'pie2dHeader',
    232: 'doughnut2dHeader',
    233: 'bubbleHeader',
    234: 'sparkwinlossHeader',
    235: 'pyramidHeader',
    236: 'funnelHeader',
    237: 'stackedcolumn2dHeader',
    238: 'stackedbar2dHeader',
    239: 'kpiHeader',
    240: 'angulargaugeHeader',
    241: 'enterChartDimensions',
    242: 'availableFields',
    245: 'hideEye',
    246: 'revertTooltip',
    247: 'addExpression',
    249: 'fieldsTableFormat',
    250: 'formatHelp',
    251: 'fieldsTableShowMine',
    252: 'showMineHelp',
    260: 'tabularHelp',
    261: 'xAxisItem',
    262: 'oAxisItem',
    263: 'axisHelp',
    264: 'multiSeries',
    265: 'singleSeries',
    266: 'enterValue',
    270: 'addUserDefined',
    271: 'helpDefinedReport',
    272: 'close',
    273: 'youChose',
    274: 'labelSelect',
    275: 'search',
    276: 'emptyResult',
    277: 'addToMenu',
    278: 'toastText',
    279: 'clearAll',
    281: 'no_options_text',
    283: 'appliedFilters',
    285: 'OldGenerator',
    290: 'barAndColTooltip',
    291: 'lineTooltip',
    292: 'pieAndDoughnutTooltip',
    293: 'bubbleTooltip',
    294: 'gaugeTooltip',
    295: 'pyramidTooltip',
    296: 'kpiTooltip',
    297: 'multiColAndBarTooltip',
    298: 'multiLineTooltip',
    299: 'multiStackedColumnTooltip',
    300: 'commonXAxisPlaceHoder',
    301: 'commonYAxisPlaceHoder',
    302: 'pieCategoryPlaceHolder',
    303: 'doughnutCategoryPlaceHolder',
    304: 'valuesPlaceHolder',
    305: 'bubbleXAxisPlaceHoder',
    306: 'bubbleXAxisStartRange',
    307: 'bubbleXAxisEndRange',
    308: 'bubbleYAxisPlaceHoder',
    309: 'bubbleYAxisStartRange',
    310: 'bubbleYAxisEndRange',
    311: 'bubbleCategoryPlaceHolder',
    312: 'bubbleSizePlaceHolder',
    313: 'gaugeScalePlaceHolder',
    314: 'gaugeMeasuredValuePlaceHolder',
    315: 'cardValuePlaceHolder',
    316: 'msPrimaryXAxisPlaceHolder',
    317: 'msSecondaryXAxisPlaceHolder',
    318: 'msYAxisPlaceHolder',
    319: 'singleSeriesTopXHelp',
    320: 'multiSeriesTopXHelp',
    321: 'scaleChartHelp',
    322: 'funnelTooltip',
    323: 'columnChart',
    324: 'lineChart',
    325: 'msColumnsChart',
    326: 'pyramidCategoryPlaceHolder',
    328: 'funnelCategoryPlaceHolder',
    335: 'typeTabTitleStep',
    336: 'dataStep',
    337: 'axesStep',
    338: 'nextStepTitle',
    339: 'nextStepMessage',
    340: 'maximum',
    341: 'minimum',
    342: 'convertDecimal',
    343: 'roundToWhole',
    344: 'absoluteValueInt',
    345: 'helpFunctionsDialog',
    346: 'placeholderText',
    353: 'dataInclusion',
    354: 'dataInclusionHelp',
    355: 'oneSubformRestriction',
    357: 'absoluteValueReal',
    358: 'calcFormsTooltip'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
